import { Flex, Spinner, Text } from "@chakra-ui/react";
import { useProjectsQuery } from "@iloq/partner-program/views/projects-list/use-projects-query";
import { ErrorMessage } from "@iloq/shared-react/error-message";
import { ReactElement, useContext } from "react";
import { PartnerStatsLinkButtons } from "./partner-stats-link-buttons";
import { FormattedMessage } from "react-intl";
import VueContext from "@iloq/shared-react/vueContext";

export function PartnerProjects({
  isDisabled,
  createLinkDisabled,
}: {
  isDisabled?: boolean;
  createLinkDisabled?: boolean;
}): ReactElement {
  const vueContext = useContext(VueContext);
  const currencyCode = vueContext.$store.state.partnerInfo.partnerInfo.currencyCode;

  const projectsQuery = useProjectsQuery(currencyCode, isDisabled);

  if (projectsQuery.isFetching) {
    return (
      <Flex flexDir="column" gap={{ base: "0", lg: "2" }} flex="50%">
        <Text fontWeight="bold" maxWidth={{ base: "140px", lg: "none" }} lineHeight="40px">
          <FormattedMessage id="partnerProgram.hero.projects" />
        </Text>
        <Spinner />
      </Flex>
    );
  }

  if (projectsQuery.isError) {
    return (
      <Flex flexDir="column" gap={{ base: "0", lg: "2" }} flex="50%">
        <Text fontWeight="bold" maxWidth={{ base: "140px", lg: "none" }} lineHeight="40px">
          <FormattedMessage id="partnerProgram.hero.projects" />
        </Text>
        <ErrorMessage message={projectsQuery.error.message} />
      </Flex>
    );
  }

  const count = projectsQuery.data?.length ?? 0;

  return (
    <PartnerStatsLinkButtons
      titleKey="partnerProgram.hero.projects"
      count={count}
      titleLink="/partner_program/projects"
      createKey="partnerProgram.hero.newProject"
      createLink="/partner_program/projects/create"
      isDisabled={isDisabled}
      createLinkDisabled={isDisabled || createLinkDisabled}
    />
  );
}
